module.exports = __webpack_public_path__ + "img/home-banner.cc368150.jpg";